import * as React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import {
	MenuItem,
	Select,
	FormControl,
	InputLabel,
  Theme,
  FormHelperText
} from "@material-ui/core/";
import { useStore } from '../../store/StoreProvider';
import { TRoute } from '../../store/Types';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import CustomButton from '../../shared/Button';

const useFormStyles = makeStyles(() => ({
	formControl: {
    minWidth: "100%",
    position: 'relative',
    '&:first-child': {
      marginBottom: '8px'
    }
	},
	button: {
		marginTop: "30px"
	}
}));

const OrderForm = () => {
  const { getCoordinates, addresses } = useStore();
	const [route, setRoute] = React.useState<TRoute>({
		from: "",
		to: ""
  });

	const classes = useFormStyles();

	const onChange = event => {
		let input = event.target;
		setRoute({ ...route, [input.name]: input.value });
	};

	const onSubmit = () => {
		getCoordinates(route);
  };

	return (
    <>
      <FormControl className={classes.formControl}>
        <InputLabel htmlFor="from">Откуда</InputLabel>
        <AddressSelect
          addressKey="from"
          otherAddress={route.to}
          onChange={onChange}
          route={route}
          values={addresses}
        />
      </FormControl>
      <FormControl className={classes.formControl}>
        <InputLabel htmlFor="to">Куда</InputLabel>
        <AddressSelect
          addressKey="to"
          otherAddress={route.from}
          onChange={onChange}
          route={route}
          values={addresses}
        />
      </FormControl>
      <CustomButton fullWidth onClick={onSubmit} classname={classes.button}>
        Заказать
      </CustomButton>
    </>
	);
}

type SelectProps = {
  addressKey: string;
  otherAddress: string;
  values: string[];
  onChange(e: React.ChangeEvent<{ name?: string; value: unknown; }>): void;
  route: TRoute;
}

export function AddressSelect(props: SelectProps) {
  const { addressKey, otherAddress, values, onChange, route } = props
  const availableAddresses = values
    .filter(item => item !== otherAddress)
    .map(addressItem => (
      <MenuItem key={addressItem} value={addressItem}>
        {addressItem}
      </MenuItem>
    ));

  return (
    <Select
      value={route[addressKey]}
      onChange={onChange}
      inputProps={{ name: addressKey, id: addressKey }}
      IconComponent={KeyboardArrowDown}
      data-testid={addressKey}
      autoWidth
    >
      {availableAddresses}
    </Select>
  );
};

export default OrderForm;
